import { render, staticRenderFns } from "./Border.vue?vue&type=template&id=76d5c53e&scoped=true&"
import script from "./Border.vue?vue&type=script&lang=ts&"
export * from "./Border.vue?vue&type=script&lang=ts&"
import style0 from "./Border.vue?vue&type=style&index=0&id=76d5c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5c53e",
  null
  
)

export default component.exports